import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { HIT_FOR_ROUND, HIT_FOR_TURN } from "../../Constants/RulesCommonConstants";
import { LocalizationContents } from "../../LocalizationContents";
import { GameLogic } from "../../Logic/GameLogic";
import { DropDownScoreLog, GameModel, IScoreLogItem } from "../../Models/GameModel";
import { RawContainerController } from "./Dropdown/RawContainerController";
import { IScrollControllerOptions, ScrollController } from "./Dropdown/ScrollController";

export interface IDropdownControllerOptions {
    onOpen: () => void,
    onClose: () => void,
}

export class DropdownController extends AnimationBaseController {
    $model: GameModel;
    private _isOpened = false;
    private readonly _optionsHeight = 390;
    private readonly _contentY0 = -176;
    public constructor(
        @Inject private _options: IDropdownControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super("DropdownController");

    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            childControllers: {
                RawContainer: {
                    instanceName: 'raw_container',
                    view: RawContainerController,
                    model: this.$model
                },
                Scroll: {
                    instanceName: 'scroll',
                    view: ScrollController,
                    model: this.$model,
                    options: <IScrollControllerOptions>{
                        onScroll: (percent) => {
                            const container = this.$childControllers.get<RawContainerController>('RawContainer');
                            container.y = this._contentY0 - (container.height - this._optionsHeight) * percent;
                        }
                    }
                }
            },
            modelWatch: {

            },
            onTap: (e)=> {
                // обрабатываем клики только по самому дропдауну (отсекаем клики по контенту)
                if (e.screenPosition.y > this._contentY0) {
                    return;
                }

                if (this._isOpened) {
                    this._options.onClose();
                } else {
                    this._options.onOpen();
                }
            },
            onPointerUpOutside: () => {
                if (this._isOpened) {
                    this._options.onClose();
                }
            }
        };
    }

    protected onInitialize(): void {
        this._setResultOption(this.$model.scoresLog);
    }

    setData(scoresLog: DropDownScoreLog[]) {
        this._setResultOption(scoresLog);
        this.$childControllers.get<RawContainerController>('RawContainer').setData(scoresLog);
    }

    open() {
        this._isOpened = true;
        const container = this.$childControllers.get<RawContainerController>('RawContainer');
        container.y = this._contentY0;
        const scroll = this.$childControllers.get<ScrollController>('Scroll');
        scroll.visible = !(container.height <= this._optionsHeight);
        scroll.reset();
        this.gotoAndStop('open');
    }

    close() {
        this.gotoAndStop('close');
        this._isOpened = false;
    }

    private _setResultOption(scoresLog: DropDownScoreLog[]) {
        const item = scoresLog[0].list[0];
        this.updateLocale(scoresLog);
        if (item) {
            // Выставляем значения
            const sign = item.delta < 0 ? '-' : '+';

            this.setTextByQuery("txt_up.result_score_total_text", item.total.toString());
            this.setTextByQuery("txt_up.rersult_score_delta_text", `(${sign}${item.delta})`);

            this.setTextByQuery("txt_up.rersult_city_value_text", item.city.toString());
            this.setTextByQuery("txt_up.rersult_edge_value_text", item.edge.toString());
            this.setTextByQuery("txt_up.rersult_line_value_text", item.line.toString());
        } else {
            this.setTextByQuery("txt_up.result_move_text", '');
            this.setTextByQuery("txt_up.result_score_total_text", '');
            this.setTextByQuery("txt_up.rersult_score_delta_text", '');

            this.setTextByQuery("txt_up.rersult_city_value_text", '');
            this.setTextByQuery("txt_up.rersult_edge_value_text", '');
            this.setTextByQuery("txt_up.rersult_line_value_text", '');
        }
    }

    updateLocale(scoresLog: DropDownScoreLog[]) {
        if (scoresLog.length && scoresLog[0].list.length) {
            const moveStr = " " + LocalizationContents.getText("tablo_move_number");
            this.setTextByQuery("txt_up.result_move_text", moveStr.replace('{{string}}', (scoresLog[0].list.length).toString()).toLocaleUpperCase());
        }
    }
}